var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { TrackIdent } from '../../learnware/LearnwareEnums';
export class CycleNavigate {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get cycle() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    handleNextClick(e) {
        this.app.appClock.isAppClockPaused = false;
        e.preventDefault();
        if (this.cycle.cycleInfo.isShowingReward || !this.app.answer) {
            this.app.directive.directiveStartNewCycle.startNewCycleByReload();
            return false;
        }
        if (this.app.answer.answerInfo.deltaToActiveQuestion < 0) {
            if (!this.app.tray.trayAnswers.frontalAnswer)
                return false;
            this.app.tray.trayAnswers.frontalAnswer.stageMe();
            return false;
        }
        if (this.app.question && this.app.question.answeringState.isInAnsweringState) {
            this.app.question.answer.answerSkip.blockQuestion();
            return false;
        }
        if (this.app.question && this.app.question.answeringState.isInFeedbackState) {
            const question = this.app.question;
            question.answer.wasContinuedImmedately = true;
            this.app.directive.directiveFinishQuestion.finishAnswer();
            this.app.track.trackEvent({
                ident: TrackIdent.ContinueImmediatelyAfterAnswer,
                question_id: question.id,
                answer_id: question.answer.id,
            });
            return false;
        }
        return false;
    }
    handlePreviousClick(e) {
        e.preventDefault();
        if (!this.app.answer.answerInfo.previousAnswerInTray)
            return false;
        this.app.answer.answerInfo.previousAnswerInTray.stageMe();
        return false;
    }
    get previousHref() {
        const { previousAnswerInTray } = this.app.answer.answerInfo;
        if (!previousAnswerInTray)
            return this.app.appUrl.pathname;
        return `${this.app.appUrl.pathname}?a=${previousAnswerInTray.id}`;
    }
}
__decorate([
    action.bound
], CycleNavigate.prototype, "handleNextClick", null);
__decorate([
    action.bound
], CycleNavigate.prototype, "handlePreviousClick", null);
